import {
    CART_STORAGE_KEY,
    normalizeCart,
    useCartStore,
} from '~/stores/cart.store'

const readCartFromStorage = () => {
    try {
        const rawCart = localStorage.getItem(CART_STORAGE_KEY)

        if (!rawCart) {
            return []
        }

        return normalizeCart(JSON.parse(rawCart))
    } catch {
        localStorage.removeItem(CART_STORAGE_KEY)

        return []
    }
}

const writeCartToStorage = (cart: unknown) => {
    try {
        const normalizedCart = normalizeCart(cart)

        if (normalizedCart.length === 0) {
            localStorage.removeItem(CART_STORAGE_KEY)
            return
        }

        localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(normalizedCart))
    } catch {
        localStorage.removeItem(CART_STORAGE_KEY)
    }
}

export default defineNuxtPlugin((nuxtApp) => {
    const cartStore = useCartStore()

    const syncStoreFromStorage = () => {
        cartStore.hydrateCart(readCartFromStorage())
    }

    const handleStorage = (event: StorageEvent) => {
        if (event.storageArea !== localStorage) {
            return
        }

        if (event.key !== null && event.key !== CART_STORAGE_KEY) {
            return
        }

        syncStoreFromStorage()
    }

    let unsubscribe: (() => void) | undefined

    nuxtApp.hook('app:mounted', () => {
        syncStoreFromStorage()

        unsubscribe = cartStore.$subscribe(
            (_mutation, state) => {
                if (!state.isHydrated) {
                    return
                }

                writeCartToStorage(state.cart)
            },
            {
                detached: true,
                flush: 'sync',
            }
        )

        window.addEventListener('storage', handleStorage)
    })

    if (import.meta.hot) {
        import.meta.hot.dispose(() => {
            unsubscribe?.()
            window.removeEventListener('storage', handleStorage)
        })
    }
})
